import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  Collapse,
  DatePicker,
  Spin,
  Col,
  InputNumber,
  Input,
  Row,
  Typography,
  Tooltip,
  Divider,
  Card,
  Table,
  Form,
  Select,
  Button,
} from "antd";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
// import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../../../components/layouts/MainLayout";
import CustomButton from "../../../../../../components/custom/CustomButton";
import TopContent from "../../../../../../components/layouts/TopContent";
import cnt from "../../../../../../services/definedConstant";
import { BOM } from "../../../../../../services/definedMethod";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";
import styles from "../../../../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../../../../components/CheckerModal";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const PayCharge = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const { state } = useLocation();
  const { Text } = Typography;
  const dispatch = useDispatch();
  const [useForm] = Form.useForm();

  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [chargeId, setChargeId] = useState(null);
  const [chargesList, setChargesList] = useState([]);
  const [chargesDetails, setChargesDetails] = useState([]);
  const [chargesTableDetails, setChargesTableDetails] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getTemplate();
    console.log(state);
  }, []);

  const getTemplate = () => {
    setIsLoading(true);

    let body = {
      session,
    };

    const url = `${apiConfig.Clients}/${state.id}/charges/${state.recordDetails.id}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res;
        let tempArray = [];

        // console.log(objList);
        // return;
        useForm.setFieldsValue({
          amount: objList.amountOutstanding,
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setChargesList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  function onCancel() {
    navigate("/detail-charge", {
      state: { ...state },
    });
  }

  function backOnClick() {
    navigate("/detail-charge", {
      state: { ...state },
    });
  }

  const onSubmit = (formValues) => {
    formValues.transactionDate = formValues.transactionDate
      ? BOM.DateTime(formValues.transactionDate, "only-date")
      : formValues.transactionDate;

    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
    };

    // console.log(body);
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      `${apiConfig.Clients}/${state.id}/charges/${state.recordDetails.id}?command=paycharge`,
      (err, res) => {
        if (err) {
          // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.payChargeMsg);
          navigate("/detail-customer", {
            state: { ...state },
          });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          // BOM.AlertMsg(cnt.SUCCESS, labelConfig.payChargeMsg);
          navigate("/detail-customer", {
            state: { ...state },
          });
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.payCharge}
        pageItems={staticConfig.payChargeBreadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          style={{
            marginBottom: 25,
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={backOnClick}
              >
                <Text
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                    fontSize: 15,
                  }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form
            style={{ paddingTop: 20, marginBottom: 20 }}
            form={useForm}
            layout="vertical"
            onFinish={onSubmit}
          >
            <Row style={{ justifyContent: "space-betwen" }}>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  name="amount"
                  label={<Text strong>{labelConfig.amount}</Text>}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.amount),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                  />
                </Form.Item>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  name="transactionDate"
                  label={<Text strong>{labelConfig.transactionDate}</Text>}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.transactionDate),
                    },
                  ]}
                >
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Divider />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#3E2336"
                colorText="white"
                hoverBackground="#3E2336"
                onClick={onSubmit}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(PayCharge);
